import VcomProvider from '../../VcomProvider';

const EndpointHelper = {
  baseUrl(url) {
    return `${VcomProvider.baseUrl}${url}`;
  },
};
export default EndpointHelper;
